// @flow

import Link from './link';
import LinkStyled from './link.styled';

export {
  LinkStyled,
};

export type { Props } from './link';

export default Link;
